import type { ReactNode } from "react";

/** Screenshot size of the real app captures in src/assets/screens. */
export const SCREEN_WIDTH = 804;
export const SCREEN_HEIGHT = 1748;

interface PhoneFrameProps {
  /** One or more <img> elements; each fills the screen (see .pf-screen > img). */
  children: ReactNode;
  size?: "md" | "lg";
  className?: string;
}

/**
 * CSS iPhone frame. No fake status bar or island: the screenshots already
 * contain the real status bar.
 */
const PhoneFrame = ({ children, size = "md", className = "" }: PhoneFrameProps) => (
  <div className={`pf-phone ${size === "lg" ? "pf-phone--lg" : ""} ${className}`}>
    <div className="pf-screen">{children}</div>
  </div>
);

export default PhoneFrame;
